import React from 'react'

const IconArrowDown = () => {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.99996 15.367L0.772461 10.1395L1.5385 9.37342L5.45829 13.3013V0.192383H6.54163V13.2932L10.4614 9.37342L11.2275 10.1395L5.99996 15.367Z" fill="#686867" />
    </svg>
  )
}

export default IconArrowDown
